import { HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { BearerHttpService } from '../bearer-http';
import { DAL_OPTIONS, DalOptions } from '../dal.module';
import {
  EduContentTocLearningDomainMap,
  EduContentTocLearningDomainServiceInterface,
  GetBookLearningDomainsQuery,
  GetTocLearningDomainsQuery,
} from './edu-content-toc-learning-domain.service.interface';

@Injectable({
  providedIn: 'root',
})
export class EduContentTocLearningDomainService implements EduContentTocLearningDomainServiceInterface {
  private bearerHttpService = inject(BearerHttpService);
  private dalOptions = inject<DalOptions>(DAL_OPTIONS);
  private baseUrl = `${this.dalOptions.campusApiBaseUrl}/learning-domains`;

  getForToc({
    eduContentTOCId,
    includeChildren,
    includeAncestors,
  }: GetTocLearningDomainsQuery): Observable<EduContentTocLearningDomainMap> {
    const params = new HttpParams({
      fromObject: {
        includeChildren: String(!!includeChildren),
        includeAncestors: String(!!includeAncestors),
      },
    });
    return this.bearerHttpService.get<EduContentTocLearningDomainMap>(`${this.baseUrl}/toc/${eduContentTOCId}`, params);
  }

  getForBook({ eduContentBookId }: GetBookLearningDomainsQuery): Observable<EduContentTocLearningDomainMap> {
    return this.bearerHttpService.get<EduContentTocLearningDomainMap>(`${this.baseUrl}/book/${eduContentBookId}`);
  }
}
